var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEndtoend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8081 29.0654H40.3237C46.847 29.0654 52.1318 23.7267 52.1318 17.1369C52.1318 13.8456 50.8089 10.8599 48.6767 8.69883C46.5374 6.54488 43.5889 5.20844 40.3237 5.20844H2",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3237 29.0654H13.8081C7.29185 29.0654 2 34.404 2 40.9939C2 44.2852 3.32296 47.2709 5.46222 49.432C7.60148 51.5859 10.55 52.9224 13.8081 52.9224H52.1318",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3319 1H2V9.41677H10.3319V1Z",
    fill: "white",
    stroke: "#1D135E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5917 47.7141C51.4541 47.7141 53.7575 50.0553 53.7577 52.9221C53.7577 55.789 51.4542 58.131 48.5917 58.131C45.7291 58.131 43.4257 55.789 43.4257 52.9221C43.4259 50.0553 45.7292 47.7141 48.5917 47.7141Z",
    fill: "#19D0E0",
    stroke: "#1D135E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEndtoend);
export default __webpack_public_path__ + "static/media/icon_endtoend.bf1cf461b8d095e1d9c247053aaea855.svg";
export { ForwardRef as ReactComponent };